/**
 * Global dialog service (replaces native alert/confirm).
 * Uses the same listener that DialogContainer registers on mount.
 */

let dialogListener = null

export function setDialogListener(fn) {
  dialogListener = fn
}

/**
 * Shows an alert dialog (message + OK only).
 * @param {string} message - Message to show
 * @param {string} [title=''] - Optional title
 * @returns {Promise<void>}
 */
export function showAlert(message, title = '') {
  return new Promise((resolve) => {
    if (dialogListener) {
      dialogListener({ type: 'alert', message, title, resolve })
    } else {
      resolve()
    }
  })
}

/**
 * Shows a confirmation dialog (Cancel / Confirm).
 * @param {string} message - Message to show
 * @param {object} [options] - Options
 * @param {string} [options.title='Confirm'] - Title
 * @param {string} [options.confirmLabel='Confirm'] - Confirm button label
 * @param {string} [options.cancelLabel='Cancel'] - Cancel button label
 * @param {string} [options.variant='default'] - 'default' | 'danger' (for delete, etc.)
 * @returns {Promise<boolean>} - true if confirmed, false if cancelled
 */
export function showConfirm(message, options = {}) {
  const {
    title = 'Confirm',
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    variant = 'default',
  } = typeof options === 'string' ? { title: options } : options

  return new Promise((resolve) => {
    if (dialogListener) {
      dialogListener({
        type: 'confirm',
        message,
        title,
        confirmLabel,
        cancelLabel,
        variant,
        resolve,
      })
    } else {
      resolve(false)
    }
  })
}
